import {
  EligibleCreditOfferQuery,
  EligibleCreditOfferQueryVariables,
} from "@outschool/gql-frontend-generated";
import { gql, useQuery } from "@outschool/ui-apollo";

const ELIGIBLE_CREDIT_OFFER_QUERY = gql`
  query EligibleCreditOffer {
    eligibleCreditOffer {
      amountCredits
      offerType
      eligiblePlans
    }
  }
`;

export type CreditOffer = NonNullable<
  EligibleCreditOfferQuery["eligibleCreditOffer"]
>;

export function useCreditOffer() {
  const { data, loading, error } = useQuery<
    EligibleCreditOfferQuery,
    EligibleCreditOfferQueryVariables
  >(ELIGIBLE_CREDIT_OFFER_QUERY, {
    fetchPolicy: "cache-and-network",
  });

  return {
    creditOffer: data?.eligibleCreditOffer || null,
    loading,
    error,
  };
}
